<template>
    <EpiLink
        :target="target"
        :title="title"
        :url="href"
        class="flex justify-between items-center border-black border-b whitespace-nowrap gap-2 group"
    >
        <span class="whitespace-nowrap mb-0">{{ text }}</span>
        <div class="pl-0 pr-2 group-hover:pr-0 group-hover:pl-2  transition-all">
            <font-awesome-icon icon="arrow-right" class="py-2.5 w-7 h-5"/>
        </div>
    </EpiLink>
</template>

<script>
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';

export default {
    components: {EpiLink},
    props: {
        text: String,
        href: String,
        target: String,
        title: String
    },
};
</script>
